var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FE4141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45772 9.117C7.74472 9.117 8.63572 8.343 8.63572 7.173C8.63572 6.282 8.19472 5.805 6.85372 5.292C5.90872 4.923 5.60272 4.689 5.60272 4.275C5.60272 3.888 5.94472 3.591 6.39472 3.591C6.81772 3.591 7.18672 3.843 7.40272 4.311L8.33872 3.735C7.94272 2.979 7.27672 2.592 6.43072 2.592C5.26072 2.592 4.47772 3.285 4.47772 4.302C4.47772 5.211 4.94572 5.688 6.25972 6.201C7.18672 6.57 7.51072 6.84 7.51072 7.272C7.51072 7.803 7.10572 8.118 6.47572 8.118C5.74672 8.118 5.25172 7.695 5.17072 6.948L4.05472 7.227C4.23472 8.37 5.20672 9.117 6.45772 9.117Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/Sell.d9fd2423f4945ef0c4a63a4ae8275da7.svg";
export { ForwardRef as ReactComponent };